import { render, staticRenderFns } from "./RequestDiffFieldBadge.vue?vue&type=template&id=a29b200c&"
import script from "./RequestDiffFieldBadge.ts?vue&type=script&lang=ts&"
export * from "./RequestDiffFieldBadge.ts?vue&type=script&lang=ts&"
import style0 from "./RequestFieldBadge.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
